/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { notificationIndex } from '../../axios/notificationIndex'
import type { NotificationIndexError, NotificationIndexResponse } from '../../types/NotificationIndex'

export const notificationIndexQueryKey = () => [{ url: '/notifications' }] as const

export type NotificationIndexQueryKey = ReturnType<typeof notificationIndexQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/NotificationController.php NotificationController::index */
export function notificationIndexQueryOptions(config?: AxiosRequestConfig) {
	return queryOptions<
		NotificationIndexResponse,
		AxiosError<NotificationIndexError>,
		NotificationIndexResponse,
		NotificationIndexQueryKey
	>({
		queryKey: notificationIndexQueryKey(),
		queryFn: ({ signal }) => notificationIndex({ signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/NotificationController.php NotificationController::index */
export function useNotificationIndex<TSelectData = NotificationIndexResponse>(
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					NotificationIndexResponse,
					AxiosError<NotificationIndexError>,
					TSelectData,
					NotificationIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<NotificationIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...notificationIndexQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/NotificationController.php NotificationController::index */
export function useNotificationIndexSuspense<TSelectData = NotificationIndexResponse>(
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					NotificationIndexResponse,
					AxiosError<NotificationIndexError>,
					TSelectData,
					NotificationIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<NotificationIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...notificationIndexQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
